<script setup lang="ts">
import { onMounted, provide } from 'vue'
import { RouterLink } from 'vue-router'
import { AppAlert, APP_LINK_COMPONENT, AppModal, useModal } from '@staff/ui'

import { useMetadata } from '@/composables/useMetadata'
import { useAuthWatcher } from '@/composables/useAuthWatcher'
import { usePersonnelDirectory } from '@/composables/usePersonnelDirectory'
import { useTokenRefresh } from '@/composables/useTokenRefresh'
import { hasStaffSession } from '@/services/auth'

provide(APP_LINK_COMPONENT, RouterLink)

const { modalStack, closeModal } = useModal()

const handleModalOpenChange = (index: number, open: boolean) => {
  if (!open) {
    if (index !== modalStack.value.length - 1) return
    closeModal()
  }
}

useAuthWatcher()
useTokenRefresh()

const { loadPersonnelDirectory } = usePersonnelDirectory()
const { loadMetadata } = useMetadata()

onMounted(() => {
  if (hasStaffSession()) {
    void loadMetadata()
    void loadPersonnelDirectory().catch(() => undefined)
  }
})
</script>

<template>
  <RouterView />
  <AppAlert />

  <AppModal
    v-for="(modal, index) in modalStack"
    :key="modal.id"
    :model-value="true"
    :closable="modal.closable && index === modalStack.length - 1"
    :size="modal.size"
    @update:model-value="handleModalOpenChange(index, $event)"
  >
    <template #title>
      {{ modal.title }}
    </template>
    <component :is="modal.component" v-bind="modal.props" @close="closeModal" />
  </AppModal>
</template>
